import { language } from "@chef/constants";

export const intl = (
  {
    no: {
      REQUIRED: "Obligatorisk",
      REDEEM: "Legg til",
      ENTER_CODE: "Skriv inn kode",
      INVALID_DISCOUNT_CODE: "Rabattkoden er ikke gyldig",
      INVALID_GIFTCARD_CODE: "Gavekortet er ikke gyldig",
      THE_CODE_HAS_BEEN_ADDED: "Koden er lagt til listen nedenfor!",
    },
    se: {
      REQUIRED: "Obligatoriskt",
      REDEEM: "Lös in",
      ENTER_CODE: "Ange kod",
      INVALID_DISCOUNT_CODE: "Rabattkoden är inte giltig",
      INVALID_GIFTCARD_CODE: "Presentkortet är inte giltigt",
      THE_CODE_HAS_BEEN_ADDED: "Rabatten läggs till i listan nedanför!",
    },
    dk: {
      REQUIRED: "Påkrævet",
      REDEEM: "Indløs",
      ENTER_CODE: "Indtast kode",
      INVALID_DISCOUNT_CODE: "Rabatkoden er ikke gyldig",
      INVALID_GIFTCARD_CODE: "Gavekortet er ikke gyldigt",
      THE_CODE_HAS_BEEN_ADDED: "Koden tilføjet til listen nedenfor!",
    },
  } as const
)[language];
